const spacings = {
  TINY: 2,
  SMALL: 4,
  MEDIUM: 8,
  LARGE: 16,
  BIG: 24,
  BIGGER: 32,
  HUGE: 40,
}

const colors = {
  BRAND_THEME: '#FFFFFF',
  BRAND_PRIMARY_ACTION: '#24397A',
  BRAND_PRIMARY_BG: '#133AB7',
  BRAND_PRIMARY_GREEN: '#4BA345',
  BRAND_PRIMARY_RED: '#C94949',
  BRAND_PRIMARY_ORANGE: '#E68E00',
  BRAND_PRIMARY_WHITE: '#FFFFFF',
  BRAND_PRIMARY_WHITE_CLICKED: 'rgba(255, 255, 255, 0.5)',
  BRAND_PURE_BLACK: '#000000',
  BRAND_PRIMARY_BLACK: '#212121',
  BRAND_COLOR_GRAY_1: '#757575',
  BRAND_COLOR_GRAY_2: '#9E9E9E',
  BRAND_COLOR_GRAY_3: '#E0E0E0',
  BRAND_COLOR_GRAY_4: '#F0F0F0',
  BRAND_COLOR_GRAY_5: '#F7F7F7',
  BRAND_COLOR_GRAY_6: '#FAFAFA',
  BG_PRIMARY_SEPARATOR: '#E0E0E0',
  BG_PRIMARY: '#F0F0F0',
  BG_SECONDARY_SEPARATOR: '#F7F7F7',
  BG_HOVER: '#FAFAFA',
  BG_WHITE: '#FFFFFF',
  BG_JIO: '#133AB7',
  BG_PRIMARY_BUTTON: '#24397A',
  BG_PRIMARY_BUTTON_HOVER: '#3333FF',
  BG_PRIMARY_BUTTON_CLICKED: '#CC9017',
  BG_SECONDARY_BUTTON_HOVER: 'rgba(51,51,255, 0.06)',
  BG_SECONDARY_BUTTON_CLICKED: 'rgba(204,144,23, 0.12)',
  BG_PRIMARY_DESTRUCTIVE: 'rgba(201, 73, 73, 1)',
  BG_SECONDAY_DESTRUCTIVE: 'rgba(201, 73, 73, 0.05)',
  BG_TERTIARY_BUTTON: '',
  BG_TERTIARY_HOVER: 'rgba(35, 105, 255, 0.06)',
  BG_TERTIARY_CLICKED: 'rgba(35, 105, 255, 0.12)',
  BG_PRIMARY_PENDING: 'rgba(230, 142, 0, 1)',
  BG_SECONDARY_PENDING_HOVER: 'rgba(230, 142, 0, 0.05)',
  BG_PRIMARY_SUCCESS: 'rgba(75, 163, 69, 1)',
  BG_SECONDARY_SUCCESS: 'rgba(75, 163, 69, 0.05)',
  BG_PRIMARY_SEPARATOR_WHITE: 'rgba(255, 255, 255, 0.16)',
  BG_SECONDARY_SEPARATOR_WHITE: 'rgba(255, 255, 255, 0.1)',
  TEXT_PRIMARY: 'rgba(33, 33, 33, 1)',
  TEXT_SECONDARY: 'rgba(117, 117, 117, 1)',
  TEXT_TERTIARY: 'rgba(158, 158, 158, 1)',
  TEXT_LINK: 'rgba(35, 105, 255, 1)',
  TEXT_LINK_HOVER: 'rgba(77, 133, 255, 1)',
  TEXT_LINK_CLICKED: 'rgba(33, 97, 235, 1)',
  TEXT_ERROR: 'rgba(201, 73, 73, 1)',
  TEXT_PENDING: 'rgba(230, 142, 0, 1)',
  TEXT_SUCCESS: 'rgba(75, 163, 69, 1)',
  TEXT_INVERSE_PRIMARY: 'rgba(255, 255, 255, 1)',
  TEXT_INVERSE_SECONDARY: 'rgba(255, 255, 255, 0.7)',
  TEXT_INVERSE_TERTIARY: 'rgba(255, 255, 255, 0.54)',
  BORDER_TEXTFIELD: 'rgba(117, 117, 117, 1)',
  BORDER_PRIMARY: 'rgba(224, 224, 224, 1)',
  BORDER_DESTRUCTIVE: 'rgba(201, 73, 73, 1)',
  BORDER_PENDING: 'rgba(230, 142, 0, 1)',
  BORDER_SUCCESS: 'rgba(75, 163, 69, 1)',
  BORDER_SECONDARY_BUTTON: 'rgba(35, 105, 255, 1)',
  SHADOW_12: 'rgba(0, 0, 0, 0.12)',
  SHADOW_16: 'rgba(0, 0, 0, 0.16)',
}

const BlueTheme = {
  colors: colors,
  space: spacings,
}

export { BlueTheme }
